<template>
	<section class="marketing-section bg-color-white">
		<MarketingPageHeader :header="header" :is-secondary="true" />
		<div class="container">
			<div class="grid-md display-flex align-items-center flex-direction-column-smo mt-300">
				<div class="col-5-md bg-color-greige-md p-225-md">
					<h3 class="heading-5-smo heading-4-md">Capture the growing demand</h3>
					<p>
						Over the past several years changing external macro conditions have exposed the limitations of a
						traditional 60/40{{ '\xa0' }}portfolio.
					</p>
					<p>
						As a result, many asset managers are now looking to alternative assets as a source of both
						greater diversification and{{ '\xa0' }}stability.
					</p>
					<p>
						For decades, large institutional investors have adopted a more modern version of portfolio
						theory, allocating anywhere from 20-50% of their total portfolio away from public markets and
						towards private-market alternatives. However, most individual investors have still yet to adopt
						this strategy with a recent 2023 Bain report suggesting that while individual investors hold
						roughly 50% of the world's total assets, they only hold roughly 16% of the world's alternative{{
							'\xa0'
						}}assets.
					</p>
				</div>
				<div class="col-7-md mt-300-smo ml-200-lg">
					<OfferingsIpoAllocationAlternatives />
				</div>
			</div>

			<hr class="bt bb-0 br-0 bl-0 my-300" />

			<div class="grid-md display-flex align-items-center flex-direction-column-reverse-smo">
				<div class="col-7-md align-self-stretch-smo mt-300-smo mr-200-md mr-400-lg">
					<ConnectApiWhyAlternativesTable />
				</div>
				<div class="bg-color-greige-md p-225-md col-5-md">
					<h3 class="heading-5-smo heading-4-md">A unique mix of the private and public markets</h3>
					<p>
						As this strategy for producing more stable returns has become increasingly mainstream, the
						demand for alternatives has grown{{ '\xa0' }}rapidly.
					</p>
					<p>
						However, without the same systems as public markets the question becomes: How can individual
						investors access the same kind of investments as family offices and{{ '\xa0' }}institutions?
					</p>
					<p>
						And how do today's modern investment platforms and apps make these types of investments
						available without the need for excessive overhead costs or other transaction related{{
							'\xa0'
						}}fees?
					</p>
					<p class="font-weight-bold">The answer: The Fundrise Connect{{ '\xa0' }}API</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import ConnectApiWhyAlternativesTable from '@components/marketing-site/connect-api/connect-api-why-alternatives-table.vue';
import { LandingPageHeader } from 'types/layout';
import MarketingPageHeader from '@components/marketing-site/marketing-page-header.vue';
import OfferingsIpoAllocationAlternatives from '@components/offerings/ipo/offerings-ipo-allocation-alternatives.vue';

const header: LandingPageHeader = {
	title: 'Why alternatives',
	heading: 'The demand for alternatives is at an <span class="no-wrap">all-time</span> high',
	summary: [
		`
		Demand for alternative investments is exploding. We make it easy for you
		to natively offer the asset classes your clients want but typically can't
		access, increasing investor satisfaction and keeping more dollars on
		your platform.`
	]
};
</script>

<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;

.p-225-md {
	@include respond-to(md) {
		padding: 2.25rem;
	}
}
</style>
